'use client'; // TODO: Need this here because so many composer elements use rebass theming. Convert to tailwind then remove this high-level use client
import React, { ElementType } from 'react';
import { getBlock } from '../../lib/composer/blocks';
import { ComposerPageProps } from '../../types/composer';
import hash from '../../lib/hash';

type Props = {
  page: ComposerPageProps;
};

/** Renders a compser page. */
const BlockRenderer = (props: Props) => {
  const { page } = props;
  const { blocks = [] } = page?.data?.content || {};
  const date = new Date(page?.modified || '');
  const modifiedDate = `${date.getDate()} ${date.toLocaleString('en-US', {
    month: 'short',
  })} ${date.getFullYear()}`;

  const blockComponents = blocks
    .map((block) => {
      const Component = getBlock(block.name) as ElementType;
      if (Component) {
        return (
          <Component
            key={hash(JSON.stringify(block))}
            modified={modifiedDate}
            nodeID={page.nodeID}
            {...block.args}
          />
        );
      }

      return null;
    })
    .filter(Boolean);

  return <>{blockComponents}</>;
};

export default BlockRenderer;
